import applyClassNames from "classnames";

import { SWReactIcons } from "@similarweb/icons";

import { ProfileAccessLevel } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";
import type { ProfileDto } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";

import {
    StyledDropdownItem,
    StyledEditButton,
    StyledItemText,
    StyledItemTextWrapper,
    StyledSimilarwebIconWrap,
} from "./styles";

type DropdownItemProps = {
    profile: ProfileDto;
    isSelected: boolean;
    canEdit: boolean;
    onClick: (profile: ProfileDto) => void;
    onSettingsClick: (profile: ProfileDto) => void;
};

const DropdownItem = (props: DropdownItemProps) => {
    const { isSelected, profile, canEdit, onClick, onSettingsClick } = props;
    const isSimilarwebProfile = profile.accessLevel === ProfileAccessLevel.Global;

    return (
        <StyledDropdownItem
            id={profile.id}
            key={profile.id}
            data-automation="employee-profile-item"
            data-automation-id={profile.id}
            data-automation-selected={isSelected}
            className={applyClassNames({ "--selected": isSelected })}
            onClick={() => onClick(profile)}
        >
            <StyledItemTextWrapper>
                <StyledItemText>{profile.name}</StyledItemText>
                {isSimilarwebProfile ? (
                    <StyledSimilarwebIconWrap>
                        <SWReactIcons
                            size="xs"
                            iconName="similar-icon"
                        />
                    </StyledSimilarwebIconWrap>
                ) : null}
            </StyledItemTextWrapper>
            {canEdit ? (
                <StyledEditButton
                    type="flat"
                    iconSize="sm"
                    iconName="settings"
                    dataAutomation="employee-profile-item-edit"
                    onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        onSettingsClick(profile);
                    }}
                />
            ) : null}
        </StyledDropdownItem>
    );
};

export default DropdownItem;
